import { render, staticRenderFns } from "./video-native.vue?vue&type=template&id=34c9c730"
import script from "./video-native.vue?vue&type=script&lang=js"
export * from "./video-native.vue?vue&type=script&lang=js"
import style0 from "./video-native.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports